import { Component, Input } from '@angular/core';
import { SocialMediaLinks } from '../../classes/SocialMediaLinks';

@Component({
	selector: 'app-social-media-share-buttons',
	templateUrl: './social-media-share-buttons.component.html',
	styleUrls: ['./social-media-share-buttons.component.scss']
})
export class SocialMediaShareButtonsComponent {

	@Input() links! : SocialMediaLinks;

	twitter() {
		window.open(this.links.twitter, "_blank");
	}
	garbageSocialMedia() {
		window.open(this.links.facebook, "_blank", "popup");
	}
	whatsApp() {
		window.open(this.links.whatsapp, "_blank");
	}
}
